@use "variables" as *;

.name {
  width: 100%;
  text-align: center;
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex-shrink: 0;
}

.skeleton {
  width: 100%;
  border-radius: 20px;
}
